import React, { forwardRef } from "react";
import { Box, Avatar, Paper, Typography } from "app/material-framework/materialComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot } from "@fortawesome/free-solid-svg-icons";
import PersonIcon from "@mui/icons-material/Person";
import { ChatbotFeedback } from "./ChatbotFeedback";
import { ChatResponse } from "./ChatbotPanel";
import { useTheme } from "@mui/material/styles";

export const ChatMessage = forwardRef(function ChatMessage(
  { idx, msg, conv_id, fullscreen, formatTimestamp, feedback, setFeedback, showFeedback = true },
  ref
) {
  const theme = useTheme();
  return (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: msg.from === "user" ? "flex-end" : "flex-start",
        mb: 2,
        mt: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: msg.from === "user" ? "row-reverse" : "row",
        }}
      >
        <Avatar
          sx={{
            bgcolor: msg.from === "user" ? theme.palette.primary.main : "#737373",
            color: "#fff",
            mr: msg.from === "user" ? 0 : 1,
            ml: msg.from === "user" ? 1 : 0,
          }}
        >
          {msg.from === "user" ? <PersonIcon /> : <FontAwesomeIcon icon={faRobot} />}
        </Avatar>
        <Paper
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: msg.from === "user" ? "#F7DEDE" : theme.palette.primary.chatBackground,
            width: "100%",
            maxWidth: fullscreen ? "90%" : "85%",
            minWidth: 0,
            wordBreak: "break-word",
            boxSizing: "border-box",
            alignSelf: msg.from === "user" ? "flex-end" : "flex-start",
            transition: "max-width 0.3s",
            position: "relative",
          }}
        >
          {msg.from === "bot" && msg.isHtml ? (
            <ChatResponse html={msg.text} fullscreen={fullscreen} />
          ) : (
            <Typography variant="body2">{msg.text}</Typography>
          )}
        </Paper>
      </Box>
      <Typography variant="caption" sx={{ color: "#888", mt: 0.5 }}>
        {formatTimestamp(msg.timestamp)}
        {msg.responseTime &&
          (msg.responseTime < 1000 ? ` (${msg.responseTime}ms)` : ` (${(msg.responseTime / 1000).toFixed(2)}s)`)}
      </Typography>
      {msg.from === "bot" && idx !== 0 && showFeedback && msg.conv_id  && (
        <ChatbotFeedback idx={idx} msg={msg} conv_id={conv_id} feedback={feedback} setFeedback={setFeedback} />
      )}
    </Box>
  );
});
